module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!doctype html>\n<html lang="en">\n  <head>\n    <meta charset="utf-8">\n    <meta http-equiv="X-UA-Compatible" content="IE=edge">\n    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no" />\n    <meta property="fullbleed" content="' +
((__t = ( htmlWebpackPlugin.options.isFullbleed )) == null ? '' : __t) +
'" />\n    <meta property="slug" content="' +
((__t = ( htmlWebpackPlugin.options.project.slug )) == null ? '' : __t) +
'" />\n    <title>' +
((__t = ( htmlWebpackPlugin.options.title )) == null ? '' : __t) +
'</title>\n  </head>\n\n  <body class="body-with-rules">\n    <div class="chart-container">\n      <h2 class="headline"></h2>\n      <h3 class="standfirst"></h3>\n      <div class="chart"></div>\n    </div>\n    <p class="source">Guardian graphic</p>\n  </body>\n\n</html>\n\n<script src="https://interactive.guim.co.uk/libs/iframe-messenger/iframeMessenger.js" type="text/javascript"></script>\n<script>iframeMessenger.enableAutoResize()</script>\n\n';

}
return __p
}